import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import PopularComics from './components/PopularComics';
import LatestUpdates from './components/LatestUpdates';
import StatsSection from './components/StatsSection';
import NewsletterSection from './components/NewsletterSection';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩国漫画网',
  url: 'https://nextdiscover.cn',
  description: '免费韩漫大全，提供好看韩国漫画在线观看。覆盖恋爱、奇幻、动作、悬疑等多种类型。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@nextdiscover.cn',
    contactType: 'customer service',
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩国漫画网',
  url: 'https://nextdiscover.cn',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://nextdiscover.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '韩国漫画网有哪些类型的韩漫？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩国漫画网提供恋爱、奇幻、动作、悬疑、搞笑、剧情、恐怖、校园等八大类型的免费韩漫大全，满足不同读者的阅读偏好。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫在线观看需要付费吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩国漫画网为读者提供免费韩漫在线观看服务，所有漫画均可免费阅读，无需支付任何费用。',
      },
    },
    {
      '@type': 'Question',
      name: '漫画更新频率如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩国漫画网坚持每日更新，确保读者能够第一时间阅读到最新的好看韩国漫画章节内容。',
      },
    },
    {
      '@type': 'Question',
      name: '如何找到自己想看的韩漫？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过漫画网址访问韩国漫画网，使用分类浏览功能按类型筛选，也可以使用搜索功能直接查找您喜欢的漫画作品。',
      },
    },
  ],
};

export default function Home() {
  const combinedSchema = { ...websiteSchema, ...organizationSchema };

  return (
    <>
      <SEOHead
        title="免费韩漫大全_好看的韩国漫画_漫画韩漫网址_韩漫在线观看"
        description="通过漫画网址访问韩国漫画网，即可浏览免费韩漫大全与好看韩国漫画，并支持韩漫在线观看，覆盖恋爱、奇幻、动作、悬疑等多种类型，便捷易用的韩漫阅读平台。"
        keywords="免费韩漫大全,好看韩国漫画,漫画网址,韩漫在线观看,韩国漫画网,韩国漫画,韩漫"
        canonicalUrl="/"
        ogType="website"
        schema={combinedSchema}
      />
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedComics />
        <CategorySection />
        <PopularComics />
        <LatestUpdates />
        <StatsSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}